import { Link, Navigate } from 'react-router-dom';
import { useAlbums, type AlbumSummary } from './useAlbums';
import { useAuth } from '../auth/AuthProvider';
import { Avatar } from '../theme/icons';

export default function AlbumsPage() {
  const { data: albums, isLoading, error } = useAlbums();
  const { user } = useAuth();

  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="min-h-full safe-top safe-bottom relative z-[1]">
      <div className="px-6 pt-6 pb-2 flex items-center justify-between">
        <div>
          <h1 className="font-sans text-2xl font-extrabold text-text leading-tight">
            Hi {user.displayName.split(' ')[0]}
          </h1>
          <p className="font-mono text-[10px] tracking-[.1em] text-muted mt-1">
            DEINE ALBEN
          </p>
        </div>
        <Link to="/me" aria-label="Profil">
          <Avatar name={user.displayName} size={40} team={Boolean(user.favoriteTeam)} />
        </Link>
      </div>

      <div className="px-4 pt-4 space-y-3">
        {isLoading && <p className="text-muted">Lade…</p>}
        {error && <p className="text-status-missing">Konnte Alben nicht laden</p>}

        {albums?.map((a) => <AlbumCard key={a.id} album={a} />)}

        {albums?.length === 0 && !isLoading && (
          <div className="bg-surface border border-border rounded-[18px] p-6 text-center">
            <p className="font-sans font-extrabold text-text">Noch in keinem Album</p>
            <p className="text-sm text-muted mt-1">
              Sag dem Admin Bescheid, er fügt dich hinzu.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

function AlbumCard({ album }: { album: AlbumSummary }) {
  const pct = album.totalStickers > 0 ? Math.round((album.have / album.totalStickers) * 100) : 0;

  return (
    <Link
      to={`/albums/${album.slug}`}
      className="block bg-surface border border-border rounded-[18px] p-[18px] active:opacity-90 transition-opacity"
    >
      <div className="flex items-start justify-between mb-3.5">
        <div>
          <h2 className="font-sans font-extrabold text-[18px] text-text leading-tight">
            {album.name}
          </h2>
          <p className="font-mono text-[10px] tracking-[.08em] text-muted mt-1">
            {album.season ? `SAISON ${album.season} · ` : ''}
            {album.totalStickers} STICKER
          </p>
        </div>
        <span
          className="w-[46px] h-[46px] rounded-[14px] flex-none"
          style={{ background: 'linear-gradient(145deg, #3B79FF, #7B5BFF)' }}
        />
      </div>

      <div className="flex items-baseline justify-between mb-1.5">
        <span className="font-mono text-[11px] text-muted">
          {album.have} / {album.totalStickers} · {album.doubles} doppelt
        </span>
        <span className="font-mono text-[12px] font-bold text-text">{pct}%</span>
      </div>
      <div className="h-2 rounded-[5px] bg-surface2 overflow-hidden mb-[15px]">
        <div
          className="h-full bg-primary rounded-[5px] transition-[width] duration-300"
          style={{ width: `${pct}%` }}
        />
      </div>

      <div className="py-3 rounded-[12px] bg-primary text-center font-sans font-bold text-[13px] text-white">
        Öffnen
      </div>
    </Link>
  );
}
